import React from "react";
import ReactApexChart from "react-apexcharts";
const BasicBarChart = ({ series, categories,heading,unit,download }) => {

  const options = {
    chart: {
      type: "bar",
      height: 400,  // Further increased chart height for more space
      toolbar: {
        show: true,
        offsetY: "100%",
        offsetX: 0,
        tools: {
          download: download === false ? undefined : '<i class="mdi mdi-download" aria-hidden="true" style="font-size: 30px;" ></i>',
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "60%",  // Slightly reduced for more spacing
        distributed: true,
      },
    },
    dataLabels: {
      position: "top",
    },
    xaxis: {
      categories: categories?.map(cat => cat.replace(" Emission", "")) || ["Scope 1", "Scope 2 ", "Scope 3", "Total GHG"],
      labels: {
        style: {
          fontSize: '11px', // Reduced font size for x-axis labels
          fontWeight: 500,
        },
        rotate: -45,
        trim: false,
        maxHeight: 120,
        offsetY: 10,
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
      tooltip: {
        enabled: true,
      },
      position: 'bottom',
    },
    grid: {
      padding: {
        bottom: 40, // Add more space below x-axis
      },
    },
    colors: [
      "#008ffb",
      "#008ffb",
      "#008ffb",
      "#008ffb",
      "#A889C4",
      "#FFA07A",
      "#90EE90",
      "#87CEEB",
      "#DDA0DD",
    ],
    tooltip: {
      y: {
        formatter: function (value) {
          return `${value} ${unit || ""}`;
        },
      },
    },
  };

  return (
    <div>
        <div id="chart">
        {heading && <h5>{heading ? heading +" ("+ unit +")" : ""}</h5>}      
        <ReactApexChart
          options={options}
          series={series}  // Proper fallback for empty data
          type="bar"
          height={350}  // Increased the height here as well
        />
      </div>
    </div>
  );
};
export default BasicBarChart;
